import { Facebook, Globe, Instagram, Mail } from "lucide-react";
import { Reveal, Kicker } from "./Reveal";
import { CtaButton } from "./CtaButton";
import {
  AUTHOR_EMAIL,
  AUTHOR_FACEBOOK,
  AUTHOR_INSTAGRAM,
  AUTHOR_NAME,
  AUTHOR_SITE,
  AUTHOR_TITLE,
} from "../../lib/site";

export const AboutSection = ({ onBuy }) => (
  <section
    id="autorka"
    data-testid="about-section"
    className="bg-cream px-6 py-24 sm:px-10 sm:py-32 lg:px-16"
  >
    <div className="mx-auto grid max-w-6xl items-center gap-14 lg:grid-cols-[1fr_1.2fr] lg:gap-20">
      <Reveal className="mx-auto w-full max-w-sm lg:max-w-none">
        <div className="relative">
          <div
            aria-hidden="true"
            className="absolute -left-4 -top-4 h-full w-full rounded-[2rem] border-2 border-brick/40"
          />
          <img
            src="/images/autorka.jpg"
            alt="Paulina Dawidowicz — prawnik i doktorantka"
            data-testid="about-photo"
            className="relative aspect-[4/5] w-full rounded-[2rem] object-cover"
          />
        </div>
      </Reveal>

      <div>
        <Reveal>
          <Kicker index="05" label="Autorka" />
          <h2 className="mt-6 font-display text-3xl font-semibold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            Dokumenty od prawnika, nie z internetu
          </h2>
          <p className="mt-5 font-display text-xl italic text-brick">{AUTHOR_NAME}</p>
          <p className="mt-1.5 text-xs font-semibold uppercase tracking-[0.22em] text-clay">
            {AUTHOR_TITLE}
          </p>
          <p className="mt-6 text-sm leading-relaxed text-clay sm:text-base">
            Jestem prawnikiem i na co dzień prowadzę prawodorzeczy.pl — pomagam
            biznesom usługowym porządkować dokumentację, regulaminy i procedury
            tak, by były zgodne z aktualnymi przepisami i realnie chroniły
            właściciela.
          </p>
          <p className="mt-4 text-sm leading-relaxed text-clay sm:text-base">
            Praca naukowa jako doktorantka pozwala mi patrzeć na przepisy
            głębiej. Pakiet Bezpieczna Restauracja to ta sama jakość dokumentów,
            z której korzystają moi klienci indywidualni — w formie, którą
            uzupełnisz samodzielnie w kilkanaście minut.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              data-testid="about-email-link"
              href={`mailto:${AUTHOR_EMAIL}`}
              className="inline-flex items-center gap-2 rounded-full border border-sand bg-white px-5 py-2.5 text-sm font-semibold text-choc transition-colors duration-300 hover:border-brick/50 hover:text-brick"
            >
              <Mail className="h-4 w-4 text-brick" />
              {AUTHOR_EMAIL}
            </a>
            <a
              data-testid="about-site-link"
              href={AUTHOR_SITE}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-sand bg-white px-5 py-2.5 text-sm font-semibold text-choc transition-colors duration-300 hover:border-brick/50 hover:text-brick"
            >
              <Globe className="h-4 w-4 text-brick" />
              prawodorzeczy.pl
            </a>
            <a
              data-testid="about-instagram-link"
              href={AUTHOR_INSTAGRAM}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-sand bg-white text-choc transition-colors duration-300 hover:border-brick/50 hover:text-brick"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              data-testid="about-facebook-link"
              href={AUTHOR_FACEBOOK}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-sand bg-white text-choc transition-colors duration-300 hover:border-brick/50 hover:text-brick"
            >
              <Facebook className="h-4 w-4" />
            </a>
          </div>
          <div className="mt-9">
            <CtaButton onBuy={onBuy} testid="about-cta-button" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
